"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var AdminStorefrontSettingsController = /** @class */ (function () {
    function AdminStorefrontSettingsController(ENV, $state, PoliciesModel, FlashService, CustomerSourceModel, PoliciesStoreService, FilesModel, ProductCategoriesModel) {
        var _this = this;
        this.ENV = ENV;
        this.busy = true;
        this.loading = true;
        this.policies = {
            storefront: {
                policymeta: {
                    id: 0,
                },
            },
        };
        this.PoliciesModel = PoliciesModel;
        this.FlashService = FlashService;
        this.PoliciesStoreService = PoliciesStoreService;
        this.handleTermsOfServiceChange =
            this.handleTermsOfServiceChange.bind(this);
        this.CustomerSourceModel = CustomerSourceModel;
        this.FilesModel = FilesModel;
        this.ProductCategoriesModel = ProductCategoriesModel;
        this.marketingOption = "";
        this.customerSources = [];
        this.productCategories = [];
        this.logoPreviewUrl = "";
        this.squareLogoPreviewUrl = "";
        this.addCustomerSource = this.addCustomerSource.bind(this);
        this.removeCustomerSource = this.removeCustomerSource.bind(this);
        this.handleLogoUpload = this.handleLogoUpload.bind(this);
        this.handleSquareLogoUpload = this.handleSquareLogoUpload.bind(this);
        this.setNavigationCategories = this.setNavigationCategories.bind(this);
        this.setPrimaryAccentColor = this.setPrimaryAccentColor.bind(this);
        this.setHoverAccentColor = this.setHoverAccentColor.bind(this);
        this.setLightAccentColor = this.setLightAccentColor.bind(this);
        CustomerSourceModel.getCustomerSources().then(function (response) {
            _this.customerSources = response.customer_sources;
        });
        ProductCategoriesModel.get().then(function (response) {
            _this.productCategories = response.categories;
        });
        var storefrontPolicy = PoliciesStoreService.getPolicy("storefront");
        if (storefrontPolicy) {
            this.policies.storefront.policymeta = storefrontPolicy.policymeta;
            this.policies.storefront.policymeta.id = storefrontPolicy.id;
            if (this.policies.storefront.policymeta
                .require_payment_method_on_shop_page === undefined) {
                this.policies.storefront.policymeta.require_payment_method_on_shop_page =
                    "N";
            }
            if (this.policies.storefront.policymeta.navigation_categories === undefined) {
                this.policies.storefront.policymeta.navigation_categories = [];
            }
            if (this.policies.storefront.policymeta.show_products_nav_link === undefined) {
                this.policies.storefront.policymeta.show_products_nav_link = "Y";
            }
            var trackingKeys = [
                "google_analytics_id",
                "google_tag_manager_id",
                "google_ads_conversion_id",
                "google_ads_conversion_label",
            ];
            trackingKeys.forEach(function (key) {
                if (_this.policies.storefront.policymeta[key] === undefined) {
                    _this.policies.storefront.policymeta[key] = "";
                }
            });
            if (this.policies.storefront.policymeta.logo_file_id) {
                this.loadLogoPreview(this.policies.storefront.policymeta.logo_file_id);
            }
            if (this.policies.storefront.policymeta.square_logo_file_id) {
                this.loadSquareLogoPreview(this.policies.storefront.policymeta.square_logo_file_id);
            }
        }
        this.busy = false;
        this.loading = false;
    }
    AdminStorefrontSettingsController.prototype.loadLogoPreview = function (fileId) {
        var _this = this;
        this.FilesModel.get(fileId)
            .then(function (response) {
            _this.logoPreviewUrl = response.temporary_url;
        })
            .catch(function (Error) { });
    };
    AdminStorefrontSettingsController.prototype.handleLogoUpload = function (formData) {
        var _this = this;
        this.busy = true;
        this.FilesModel.uploadFile("school_logo", "storefront_logo", formData)
            .then(function (response) {
            _this.policies.storefront.policymeta.logo_file_id = response.file.id;
            _this.loadLogoPreview(response.file.id);
            _this.FlashService.setMessage({
                type: "success",
                message: "Logo uploaded. Remember to click Update to save.",
            });
            _this.busy = false;
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    AdminStorefrontSettingsController.prototype.loadSquareLogoPreview = function (fileId) {
        var _this = this;
        this.FilesModel.get(fileId)
            .then(function (response) {
            _this.squareLogoPreviewUrl = response.temporary_url;
        })
            .catch(function (Error) { });
    };
    AdminStorefrontSettingsController.prototype.handleSquareLogoUpload = function (formData) {
        var _this = this;
        this.busy = true;
        this.FilesModel.uploadFile("school_logo", "storefront_square_logo", formData)
            .then(function (response) {
            _this.policies.storefront.policymeta.square_logo_file_id =
                response.file.id;
            _this.loadSquareLogoPreview(response.file.id);
            _this.FlashService.setMessage({
                type: "success",
                message: "Square logo uploaded. Remember to click Update to save.",
            });
            _this.busy = false;
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    AdminStorefrontSettingsController.prototype.setNavigationCategories = function (categories) {
        this.policies.storefront.policymeta.navigation_categories = categories;
    };
    AdminStorefrontSettingsController.prototype.addCustomerSource = function () {
        var _this = this;
        this.CustomerSourceModel.createCustomerSource({
            name: this.marketingOption,
        })
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.customerSources = _this.customerSources.concat([
                response.customer_source,
            ]);
            _this.marketingOption = "";
        })
            .catch(function (Error) { });
    };
    AdminStorefrontSettingsController.prototype.removeCustomerSource = function (id, index) {
        var _this = this;
        if (id) {
            this.CustomerSourceModel.removeCustomerSource({ id: id })
                .then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.customerSources.splice(index, 1);
            })
                .catch(function (Error) { });
        }
        else {
            this.customerSources.splice(index, 1);
        }
    };
    AdminStorefrontSettingsController.prototype.handleTermsOfServiceChange = function (data) {
        this.policies.storefront.policymeta.terms_of_service = data.html;
    };
    AdminStorefrontSettingsController.prototype.setPrimaryAccentColor = function (color) {
        this.policies.storefront.policymeta.primary_accent_color = color;
    };
    AdminStorefrontSettingsController.prototype.setLightAccentColor = function (color) {
        this.policies.storefront.policymeta.light_accent_color = color;
    };
    AdminStorefrontSettingsController.prototype.setHoverAccentColor = function (color) {
        this.policies.storefront.policymeta.hover_accent_color = color;
    };
    AdminStorefrontSettingsController.prototype.processPolicy = function () {
        var _this = this;
        this.busy = true;
        var request = __assign({ id: this.policies.storefront.policymeta.id }, this.policies.storefront.policymeta);
        this.PoliciesModel.update(request)
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.PoliciesStoreService.writePolicy("storefront", _this.policies.storefront.policymeta);
            _this.busy = false;
        })
            .catch(function (Error) {
            _this.busy = false;
        });
    };
    return AdminStorefrontSettingsController;
}());
AdminStorefrontSettingsController.$inject = [
    "ENV",
    "$state",
    "PoliciesModel",
    "FlashService",
    "CustomerSourceModel",
    "PoliciesStoreService",
    "FilesModel",
    "ProductCategoriesModel",
];
exports.default = AdminStorefrontSettingsController;
